<template>
  <div class="comp-commonheader">
    <h1 class="title">
      <a
        class="title-link"
        href="/dashboard/tools"
      >
        <img
          class="title-img"
          src="../../../public/img/laihua-logo-dark.svg"
          alt="laihua"
        >
      </a>
    </h1>
    <div class="content">
      <div class="part-1">
        <div class="current-page">
          {{ (views[$route.path.slice(1)] || {}).text }}
        </div>
        <div
          v-if="$route.path.slice(1)"
          class="how"
          @mouseenter="showTip"
          @mouseleave="hideTip"
        >
          怎么操作?
        </div>
      </div>
      <div class="part-2">
        <div
          class="complete-btn"
          @click="onComplete"
        >
          完成
        </div>
      </div>
      <tip-panel
        v-show="isShowTip"
        @mouseEnter="clearTimer"
        @mouseLeave="hideTipNow"
      ></tip-panel>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CheckMultiLogin from '@/mixins/checkMultiLogin.vue';
export default {
  components: {
    tipPanel: () => import('@/components/header/tipPanel.vue')
  },
  mixins: [CheckMultiLogin],
  data() {
    return {
      isShowTip: false,
      timer: null,
      delay: 600
    };
  },
  computed: {
    ...mapGetters({
      loginStatus: 'loginStatus',
      views: 'views/dict',
      screenshotFiles: 'screenshot/clipImages',
      videoConverterFiles: 'convert/getFiles',
      videoMergerFiles: 'merge/getFiles',
      cutterFiles: 'cutter/getFiles',
      videoSpeederFiles: 'videoSpeeder/getCompletedFiles',
      audiocutterFiles: 'audio/cutAudios',
      gifconverterFiles: 'gif/cvtGifs',
      cropperFiles: 'cropper/getFiles',
      completedFiles: 'completed/getFiles',
      sizes: 'completed/getSizes'
    }),
    myViews() {
      return {
        '': { text: '视频工具宝', path: '/' },
        ...this.views
      };
    }
  },
  watch: {
    screenshotFiles(val) {
      this.$store.commit('completed/setFiles', val);
    },
    videoConverterFiles(val) {
      console.log('turbo: videoConverterFiles -> val', val);
      this.$store.commit('completed/setFiles', val);
    },
    videoMergerFiles(val) {
      this.$store.commit('completed/setFiles', val);
    },
    cutterFiles(val) {
      this.$store.commit('completed/setFiles', val);
    },
    videoSpeederFiles(val) {
      this.$store.commit('completed/setFiles', val);
    },
    audiocutterFiles(val) {
      this.$store.commit('completed/setFiles', val);
    },
    gifconverterFiles(val) {
      this.$store.commit('completed/setFiles', val);
    },
    cropperFiles(val) {
      this.$store.commit('completed/setFiles', val);
    }
  },
  created() {
    // this.$bus.emit('autoComplete', file)
    this.$bus.on('autoComplete', (item) => {
      if (!this.loginStatus) {
        this.$store.commit('changeLoginVisible', true);
        return;
      }
      this.completeFiles([item]);
    });
  },
  mounted() {},
  methods: {
    onClickUpload() {
      console.log('bbb');
    },
    showModal() {
      this.$modal.show('completeModal');
    },
    showTip() {
      this.clearTimer();
      this.isShowTip = true;
    },
    hideTip() {
      this.clearTimer();
      this.timer = setTimeout(() => {
        this.isShowTip = false;
      }, this.delay);
    },
    clearTimer() {
      clearTimeout(this.timer);
    },
    hideTipNow() {
      this.isShowTip = false;
    },
    async getFileSize({ filename }) {
      let size = 0;
      let duration = 0;
      if (this.sizes[filename] > 0) {
        size = this.sizes[filename];
      } else {
        let resp = await this.$http.get(`/common/material/avinfo?key=${filename}`);
        let {
          data: { format: respData }
        } = resp || {};
        size = respData.size || 0;
        duration = respData.duration || 0;
      }
      if (size > 0) {
        this.$store.commit('completed/addSizeItem', { key: filename, value: size });
      }
      return { size, duration };
    },

    async onComplete() {
      // 参数1 事件名
      // 参数2 事件携带数据
      // this.$sensors.track('kkk', {
      //   a: '123'
      // });
      // this.$bus.emit('checkLogin');
      let checkResult = (await this.checkMultiLogin()) || {};

      if (!this.loginStatus || (checkResult && checkResult.type)) {
        this.storeRegisterSource('完成');
        // show login modal
        // this.$store.commit('changeLoginVisible', true);
        return;
      }
      this.$store.commit('completed/setPipeFiles', []);
      if (this.completedFiles.length) {
        this.completeFiles(this.completedFiles);
      } else {
        this.$message({ message: '目前还没有任何完成作品哦。', type: 'error' });
      }
    },
    completeFiles(files) {
      let name = this.$route.path.slice(1) + 'Files';
      let methodName = 'complete' + name[0].toUpperCase() + name.slice(1);
      if (typeof this[methodName] === 'function') {
        let formatedFiles = this[methodName](files);
        console.log('turbo: completeFiles -> formatedFiles', formatedFiles);
        this.$store.commit('completed/setPipeFiles', formatedFiles);
      }
    },
    completeFilesBase(files, outputType = 'video') {
      let tasks = [];
      let pipeData = [];
      files = files.map((item, i) => {
        let isBlob = item.cover instanceof Blob;
        let cover = isBlob ? URL.createObjectURL(item.cover) : this.$.handleAssetsUrl(item.cover);
        let size = item.size || 0;
        let ret = {
          size,
          name: item.name.toLowerCase(),
          url: this.$.handleAssetsUrl(item.url),
          cover,
          duration: item.duration,
          type: outputType,
          origin: item
        };
        pipeData[i] = {
          size: ret.size,
          name: ret.name,
          url: ret.origin.url,
          cover: ret.origin.cover,
          duration: ret.duration
        };
        tasks[tasks.length] = this.getFileSize({ filename: item.url }).then(({ size, duration }) => {
          pipeData[i].size = ret.size = size;
          pipeData[i].duration = ret.duration = duration;
        });
        return ret;
      });
      this.$modal.show('completeModal', { files, doingTasks: Promise.all(tasks) });

      return pipeData;
    },
    completeScreenshotFiles(files) {
      files = files.map((item) => {
        return {
          size: item.blob.size,
          name: item.name,
          url: URL.createObjectURL(item.blob),
          type: 'image',
          origin: item
        };
      });
      this.$modal.show('completeModal', { files });
      return files;
    },
    completeCutterFiles(files) {
      return this.completeFilesBase(files);
    },
    completeVideoConverterFiles(files) {
      let tasks = [];
      let pipeData = [];
      files = files.map((item, i) => {
        let size = 0;
        let ret = {
          size: size,
          name: item.name + '.' + item.outputFormat.toLowerCase(),
          url: this.$.handleAssetsUrl(item.url),
          cover: this.$.handleAssetsUrl(item.cover),
          duration: item.duration,
          type: 'video',
          origin: item
        };
        pipeData[i] = {
          size: ret.size,
          name: ret.name,
          url: ret.origin.url,
          cover: ret.origin.cover,
          duration: ret.duration
        };
        tasks[tasks.length] = this.getFileSize({ filename: item.url }).then(({ size, duration }) => {
          pipeData[i].size = ret.size = size;
          pipeData[i].duration = ret.duration = duration;
        });
        return ret;
      });
      this.$modal.show('completeModal', { files, doingTasks: Promise.all(tasks) });
      return pipeData;
    },
    completeVideoSpeederFiles(files) {
      return this.completeFilesBase(files);
    },
    completeAudiocutterFiles(files) {
      return this.completeFilesBase(files, 'audio');
    },
    completeGifconverterFiles(files) {
      return this.completeFilesBase(files, 'image');
    },
    completeCropperFiles(files) {
      return this.completeFilesBase(files, 'video');
    },
    completeVideoMergerFiles(files) {
      return this.completeFilesBase(files, 'video');
    }
  }
};
</script>

<style scoped lang="scss">
/* @import url(); 引入css类 */
.comp-commonheader {
  height: 80px;
  display: flex;
  & > h1 {
    width: 197px;
    background-color: #fff;
    flex-shrink: 0;
  }
  & > .content {
    position: relative;
    display: flex;
    width: 100%;
    flex-grow: 0;
    background-color: #f6f7fb;
    border-bottom: 1px solid #e2e3ea;
  }
}
.title {
  display: flex;
  justify-content: center;
  align-items: center;
}
.title-img {
  width: 92px;
  height: 26px;
}
.title-link {
}
.part-1,
.part-2 {
  display: flex;
  align-items: center;
  width: 50%;
}
.part-1 {
  justify-content: flex-start;
}
.part-2 {
  padding-right: 33px;
  justify-content: flex-end;
}
.current-page {
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  margin-left: 40px;
  margin-right: 15px;
  cursor: default;
}
.how {
  width: 74px;
  height: 20px;
  background: #f6f7fb;
  border: 1px solid #2f58fe;
  border-radius: 10px;
  font-size: 12px;
  color: #2f58fe;
  line-height: 20px;
  cursor: default;
}
.complete-btn {
  width: 120px;
  height: 40px;
  line-height: 40px;
  background: #2f58fe;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  &:hover {
    background-color: #3d7dff;
  }
}
</style>
